import React, { Component } from "react";
import intl from "react-intl-universal";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Button
} from "react-bootstrap";
import LoaderButton from "./LoaderButton";
import DivsPattern from "./skylineDesignPattern";
import "./account.css"
import ModalDialog from "./Modal";

class DeleteAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      failedMessage: "",
      isChecked : true,
      radioButtonValue: "Delete",
      showConfirmationModal:false,
      commentMessage:"",
      targetEmail: {"groups":["Licensing"]},
      isLoading: false,
    };
  }

  validateForm() {
    return (
      this.state.currentPassword.length > 0 &&
      this.state.newPassword.length > 0 &&
      this.state.confirmNewPassword.length > 0 &&
      this.state.newPassword === this.state.confirmNewPassword
    );
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleConfirmationModalClose = () =>{
    this.setState({ showConfirmationModal: false });
  };  

  handleDialog =(event) =>{
    event.preventDefault();
    this.setState({showConfirmationModal:true});
  }

  handleSubmit = event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    fetch(process.env.REACT_APP_API_URL + "UpdateUserPrivacyPreferences", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        preference: this.state.radioButtonValue,
        unsubscribeValue: 1,
        comment:this.state.commentMessage,
        email: this.props.userName,
        targetEmail: this.state.targetEmail
      })
    })
      .then(res => res.json())
      .then(result => {
        this.setState({ showConfirmationModal: false });
        this.setState({ isLoading: false });
        if (result.Result == "success") {
          if (this.state.radioButtonValue !== "Delete"){
            return this.props.history.push("/account");
          }
          else{
            fetch(process.env.REACT_APP_API_URL + "logout", {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({})
            })
            .then(res => res.json())
            .then(result => {
              if (result.Result === "Success") {
                this.props.history.replace("/account");
                this.props.userHasAuthenticated(false, undefined);
              } else{
                this.setState({ failedMessage: 'failed to logout user' });
              }
            })
          }
        } else {
          this.setState({ failedMessage: result.Message });
        }
      })
      .catch(error => {
        console.error(error);
        this.props.handleServerError(true);
        this.setState(
          { 
            showConfirmationModal: false, 
            isLoading: false, 
            failedMessage: intl.get("General_Failure") }
        );
      });
  };

  render() {
    return (
      <DivsPattern headerText={intl.get("Delete_Account_Title")} className="col-lg-11">
        <form className="form-signin">
          <label>This action will permanently delete your account. No account information will be recoverable.</label>
          <br />
          <FormGroup controlId="DeleteUser" className="form-label-group">
          <label className="privacyDeleteCommentLabel">Comment:</label>
          <textarea className="privacyDeleteCommentTextarea" placeholder = "(optional)" value={this.state.commentMessage} onChange={(event) => {this.setState({ commentMessage: event.target.value });}}>
          </textarea>
          </FormGroup>
          <LoaderButton
            block
            onClick={this.handleDialog}
            className="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2 privacyUpdateButton"
            type="submit"
            isLoading={this.state.isLoading}
            text={intl.get("Delete_Account_Button")}
            loadingText={intl.get("Update_Privacy_Loading")}
          />
          <ModalDialog
            show={this.state.showConfirmationModal}
            className={"DeleteUser"}
            handleClose={this.handleConfirmationModalClose}
            title={intl.get("Delete_Confirm_Title") }
            message={this.state.radioButtonValue == "Delete"? intl.get("Delete_Account_Msg_Alert"):intl.get("UnSubscribe_Alert")}
            handleSubmitClose={this.handleSubmit}
            handleButtonName={intl.get("Privacy_Delete_Button")}
            primaryButtonId={"deleteAccountButton"}
            secondaryButtonId={"cancelDeleteAccountButton"}
            handleButtonClose={intl.get("Privacy_Cancel_Button")}
            modalClassName={"deleteUserModal"}
            modelSizeWindow="lg"
            modalHeaderClass="modalHeader"
          />
          <span style={{ color: "red" }}>{this.state.failedMessage}</span>
        </form>
      </DivsPattern>
    );
  }
}

export default DeleteAccount;
